






















































import { VehicleStateEnum } from "@/lib/enum/vehicleState.enum";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { GoToHelper } from "@/lib/utility/goToHelper";
import { IVehicle } from "@/models/vehicle.entity";
import { VehicleModule } from "@/store/modules/vehicle.store";
import { Component, Prop } from "vue-property-decorator";
import BaseRef from "./BaseRef.vue";
import { IRefDetail } from "./RefsList.vue";
import Tooltip from "./tooltip.vue";

@Component({
  components: { Tooltip },
  filters: { simpleDoubleDigitDate }
})
export default class RefsVehicle extends BaseRef<IVehicle> implements IRefDetail<IVehicle> {
  @Prop()
  item!: IVehicle;

  @Prop({ default: false })
  small!: boolean;

  @Prop({ default: false })
  confirmable!: boolean;

  get title() {
    return this.item.displayName || this.item.numberplate || this.item.identificationnumber;
  }

  get isConfirmable() {
    return Boolean(this.item.state !== VehicleStateEnum.ACTIVE);
  }

  goToDetail(openInNew = true) {
    new GoToHelper(this.$router).goToVehicleDetail(this.item.id, this.item.partnerId, undefined, openInNew);
  }

  get hasOpenDetailListener() {
    return Boolean(this.$listeners && this.$listeners.openDetail);
  }

  get hasClickListener() {
    return Boolean(this.$listeners && this.$listeners.click);
  }

  getState(item: IVehicle) {
    if (!item.state) {
      return { color: "Grey", label: "" };
    }

    return VehicleModule.stateMap.get(item.state);
  }

  confirm() {
    this.$log.debug("confirm");
    this.confirmAsync();
    this.$emit("confirm", this.item);
  }

  async confirmAsync() {
    this.item.state = VehicleStateEnum.ACTIVE;

    await this.item.update();
  }
}
